import AdminRoute from "./AdminRoute";

export default AdminRoute;
